import { getParamAffixe2, getAll } from '@/api/parametrage/index';
import * as allTypes from '../mutation-type';
import * as types from './parametrage-mutation-type';

function initParametres() {
  const parametres = {};
  Object.keys(types.PARAMETRES_KEYS).forEach(key => {
    const url = types.PARAMETRES_KEYS[key];
    parametres[url] = { items: [], lastUpdate: 0 };
  });
  return parametres;
}

function initialState() {
  const parametres = initParametres();
  return {
    paramAffixe2: {},
    parametres,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_PARAM_AFFIXE2](state, payload) {
    state.paramAffixe2[payload.key] = payload.value;
  },
  [types.SET_PARAMETRE](state, { type, items }) {
    state.parametres[type] = { items, lastUpdate: new Date() };
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  loadParamAffixe2: async ({ commit }, key) => {
    const { result } = (await getParamAffixe2(key)).data;
    commit(types.SET_PARAM_AFFIXE2, { key, value: result });
  },
  async loadParametres({ state, dispatch }, types) {
    if (!types || !Array.isArray(types)) return;

    const typesLoadTask = [];
    
    types.filter(Boolean).forEach(type => {
      const param = state.parametres[type];
      let dateLimit = new Date();
      dateLimit = dateLimit.setHours(dateLimit.getHours() - 24);

      if (param && param.lastUpdate && param.lastUpdate > dateLimit) return;

      typesLoadTask.push(dispatch('loadParametreForce', type));
    });
    await Promise.all(typesLoadTask);
  },
  async loadParametreForce({ commit }, type) {
    if (!type) return;
    const res = (await getAll(type)).data.result;
    commit(types.SET_PARAMETRE, { type: type, items: res.items ? res.items : res });
  },
};

const getters = {
  paramAffixe2: state => {
    return state.paramAffixe2;
  },
  parametre: (state) => (ref) => {
    if (!ref || !state.parametres[ref]) return null;
    return state.parametres[ref].items;
  },
};


export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
